import $ from 'jquery';

export default () => {
    const wrapper = $('.wrapper');
    const modal = $('.js-video-gallery-modal');
    const trigger = $('.js-video-gallery-trigger');
    const close = $('.js-video-gallery-close');
    const video = $('.js-gallery-video');

    modal.appendTo(wrapper);

    modal.on('click', function() {
        $(this).removeClass('is-active');
    });

    video.on('click', function(e) {
        e.stopPropagation();
    });

    trigger.on('click', function() {
        const id = $(this).attr('data-id');
        modal.filter('[data-id="'+id+'"]').addClass('is-active');
    });

    if (window.location.hash !== '') {
        $(window).on('load', function(e) {
            modal.filter('[data-id="'+window.location.hash.replace('#', '')+'"]').addClass('is-active');
            $('html, body').animate({
                scrollTop: $('.js-video-galleries').offset().top - 500
            }, 500);
        });
    }

    close.on('click', function() {
        modal.filter('.is-active').removeClass('is-active');
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/video-gallery.js